{
  "apiKey": "AIzaSyDcVuX3-xNtbJ2_RG656_y_5Td9PZmA4T8",
  "authDomain": "eureka-b100a.firebaseapp.com",
  "databaseURL": "https://eureka-b100a.firebaseio.com",
  "projectId": "eureka-b100a",
  "storageBucket": "eureka-b100a.appspot.com",
  "messagingSenderId": "456819084897",
  "appId": "1:456819084897:web:b7543e6dea50cf7ff02420",
  "measurementId": "G-0F3J8MGQ88"
}